"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const FieldFocusContext_1 = require("../FieldFocusContext");
const PrettyText_1 = __importDefault(require("../PrettyText"));
const MappableField = (props) => (common_utils_1.isolateComponent(FieldFocusContext_1.ExclusiveFieldFocus, null,
    common_utils_1.isolateComponent(PrettyText_1.default, { choiceGroups: props.choiceGroups, disabledText: props.disabledText, id: props.id, initialValue: props.value, isDisabled: props.isDisabled, isErrored: props.isErrored, isMultiline: props.isMultiline, onBlur: props.onBlur, onChange: props.onChange, onFocus: () => { }, placeholder: props.placeholder })));
MappableField.defaultProps = {
    isMultiline: false,
    onBlur: () => { },
    onChange: () => { },
};
exports.default = MappableField;
